module.exports = __webpack_public_path__ + "static/media/flavia.cb5d1368.jpg";